/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CargoDriverDto } from '../models/CargoDriverDto';
import type { GetAvailablePackagesResponseDriver } from '../models/GetAvailablePackagesResponseDriver';
import type { GetEstimatedDriverRouteClientResponse } from '../models/GetEstimatedDriverRouteClientResponse';
import type { GetMonitoringPackagesResponseAdmin } from '../models/GetMonitoringPackagesResponseAdmin';
import type { GetPackageCargosMonitoringRoutesResponseAdmin } from '../models/GetPackageCargosMonitoringRoutesResponseAdmin';
import type { GetPackageNearbyDriversResponseClient } from '../models/GetPackageNearbyDriversResponseClient';
import type { GetPackagesCountByStatusAdminResponse } from '../models/GetPackagesCountByStatusAdminResponse';
import type { GetPackageStatusCanBeUpdatedToResponseAdmin } from '../models/GetPackageStatusCanBeUpdatedToResponseAdmin';
import type { GetPackageStatusLogsAdminResponse } from '../models/GetPackageStatusLogsAdminResponse';
import type { GetStreamingPackagesAdminResponse } from '../models/GetStreamingPackagesAdminResponse';
import type { GetStreamingPackagesV2AdminResponse } from '../models/GetStreamingPackagesV2AdminResponse';
import type { GetSupportedVehicleTypesClientResponse } from '../models/GetSupportedVehicleTypesClientResponse';
import type { PackageAdminDto } from '../models/PackageAdminDto';
import type { PackageClientDto } from '../models/PackageClientDto';
import type { PackageDriverDto } from '../models/PackageDriverDto';
import type { PackageStatus } from '../models/PackageStatus';
import type { Pagination1OfPackageAdminListedDto } from '../models/Pagination1OfPackageAdminListedDto';
import type { Pagination1OfPackageClientListedDto } from '../models/Pagination1OfPackageClientListedDto';
import type { PostAssignPackageRequestAdmin } from '../models/PostAssignPackageRequestAdmin';
import type { PostCancelPackageAdminRequest } from '../models/PostCancelPackageAdminRequest';
import type { PostEstimatedPackageClientResponse } from '../models/PostEstimatedPackageClientResponse';
import type { PostEstimatePackageClientRequest } from '../models/PostEstimatePackageClientRequest';
import type { PostPackageAcquireAdminRequest } from '../models/PostPackageAcquireAdminRequest';
import type { PostPackageClientRequest } from '../models/PostPackageClientRequest';
import type { PutPackageAddressRequestAdmin } from '../models/PutPackageAddressRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PackagesService {
    /**
     * @returns PackageDriverDto OK
     * @throws ApiError
     */
    public static getPackageDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<PackageDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/packages/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetAvailablePackagesResponseDriver OK
     * @throws ApiError
     */
    public static getAvailablePackagesDriver(): CancelablePromise<GetAvailablePackagesResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/packages/available',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CargoDriverDto OK
     * @throws ApiError
     */
    public static postPackageAcquireDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<CargoDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/packages/{id}/acquire',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CargoDriverDto OK
     * @throws ApiError
     */
    public static postPackageAtSourceDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<CargoDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/packages/{id}/at-source',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CargoDriverDto OK
     * @throws ApiError
     */
    public static postPackagePickedUpDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<CargoDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/packages/{id}/picked-up',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CargoDriverDto OK
     * @throws ApiError
     */
    public static postPackageDeliveringDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<CargoDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/packages/{id}/delivering',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CargoDriverDto OK
     * @throws ApiError
     */
    public static postPackageAtDestinationDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<CargoDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/packages/{id}/at-destination',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CargoDriverDto OK
     * @throws ApiError
     */
    public static postPackageCompleteDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<CargoDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/packages/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageDeclineDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/packages/{id}/decline',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PackageClientDto OK
     * @throws ApiError
     */
    public static getPackageClient({
        id,
    }: {
        id: string,
    }): CancelablePromise<PackageClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/packages/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfPackageClientListedDto OK
     * @throws ApiError
     */
    public static getPackagesClient({
        statuses,
        fromDate,
        toDate,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        statuses?: Array<PackageStatus>,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfPackageClientListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/packages',
            query: {
                'statuses': statuses,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PackageClientDto OK
     * @throws ApiError
     */
    public static postPackageClient({
        requestBody,
    }: {
        requestBody?: PostPackageClientRequest,
    }): CancelablePromise<PackageClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/packages',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetPackageNearbyDriversResponseClient OK
     * @throws ApiError
     */
    public static getPackageNearbyDriversClient({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetPackageNearbyDriversResponseClient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/packages/{id}/nearby-drivers',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PostEstimatedPackageClientResponse OK
     * @throws ApiError
     */
    public static postPackageEstimateClient({
        requestBody,
    }: {
        requestBody?: PostEstimatePackageClientRequest,
    }): CancelablePromise<PostEstimatedPackageClientResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/packages/estimate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetEstimatedDriverRouteClientResponse OK
     * @throws ApiError
     */
    public static getEstimatedDriverRouteClient({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetEstimatedDriverRouteClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/packages/{id}/estimated-driver-route',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetSupportedVehicleTypesClientResponse OK
     * @throws ApiError
     */
    public static getSupportedVehicleTypesClient({
        serviceId,
    }: {
        serviceId: number,
    }): CancelablePromise<GetSupportedVehicleTypesClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/packages/services/{serviceId}/supported-vehicle-types',
            path: {
                'serviceId': serviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewPackages`
     * @returns Pagination1OfPackageAdminListedDto OK
     * @throws ApiError
     */
    public static getPackagesAdmin({
        id,
        packageStatus,
        userId,
        serviceId,
        regionId,
        referenceCode,
        fromDate,
        toDate,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: string,
        packageStatus?: PackageStatus,
        userId?: string,
        serviceId?: number,
        regionId?: number,
        referenceCode?: string,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfPackageAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages',
            query: {
                'id': id,
                'packageStatus': packageStatus,
                'userId': userId,
                'serviceId': serviceId,
                'regionId': regionId,
                'referenceCode': referenceCode,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewPackageDetails`
     * @returns PackageAdminDto OK
     * @throws ApiError
     */
    public static getPackageAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<PackageAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewPackageDetails`
     * @returns GetPackageStatusLogsAdminResponse OK
     * @throws ApiError
     */
    public static getPackageStatusLogsAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetPackageStatusLogsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages/{id}/status-logs',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetPackageCargosMonitoringRoutesResponseAdmin OK
     * @throws ApiError
     */
    public static getCargosMonitoringRoutesAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetPackageCargosMonitoringRoutesResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages/{id}/cargos/routes/monitoring',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static putPackageAddressAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutPackageAddressRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/packages/{id}/address',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetMonitoringPackagesResponseAdmin OK
     * @throws ApiError
     */
    public static getMonitoringPackagesAdmin({
        regionIds,
        packageStatuses,
        fetchAll,
        fromDate,
        toDate,
    }: {
        regionIds: Array<number>,
        packageStatuses: Array<PackageStatus>,
        fetchAll?: boolean,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetMonitoringPackagesResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages/monitoring',
            query: {
                'fetchAll': fetchAll,
                'regionIds': regionIds,
                'packageStatuses': packageStatuses,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewStreamingPackages`
     * @returns GetStreamingPackagesAdminResponse OK
     * @throws ApiError
     */
    public static getStreamingPackagesAdmin({
        regionIds,
        packageStatuses,
        fetchAll,
        fromDate,
        toDate,
    }: {
        regionIds: Array<number>,
        packageStatuses: Array<PackageStatus>,
        fetchAll?: boolean,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetStreamingPackagesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages/streaming',
            query: {
                'fetchAll': fetchAll,
                'regionIds': regionIds,
                'packageStatuses': packageStatuses,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewStreamingPackages`
     * @returns GetStreamingPackagesV2AdminResponse OK
     * @throws ApiError
     */
    public static getStreamingPackagesV2Admin({
        cursor,
        limit,
        packageStatuses,
        regionIds,
        fromDate,
        toDate,
        trackingPanelUserId,
        referenceCode,
    }: {
        cursor?: string,
        limit?: number,
        packageStatuses?: Array<PackageStatus>,
        regionIds?: Array<number>,
        fromDate?: string,
        toDate?: string,
        trackingPanelUserId?: string,
        referenceCode?: string,
    }): CancelablePromise<GetStreamingPackagesV2AdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages/streamingv2',
            query: {
                'cursor': cursor,
                'limit': limit,
                'packageStatuses': packageStatuses,
                'regionIds': regionIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'trackingPanelUserId': trackingPanelUserId,
                'referenceCode': referenceCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageApproveAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/approve',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageAssignAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostAssignPackageRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/assign',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `UnassignOrderFromDriver`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderUnassignAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/unassign',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageAcquireAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostPackageAcquireAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/acquire',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageAtSourceAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/at-source',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackagePickedUpAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/picked-up',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageDeliveringAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/delivering',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageAtDestinationAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/at-destination',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageCompleteAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageNotDeliveredAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/not-delivered',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageCancelAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelPackageAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewPackageDetails`
     * @returns GetPackageStatusCanBeUpdatedToResponseAdmin OK
     * @throws ApiError
     */
    public static getOrderStatusCanBeUpdatedToAdmin({
        packageStatus,
    }: {
        packageStatus?: PackageStatus,
    }): CancelablePromise<GetPackageStatusCanBeUpdatedToResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages/status-can-be-updated-to',
            query: {
                'packageStatus': packageStatus,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `WatchPackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageTrackingAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/packages/{id}/tracking',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewPackages`
     * @returns GetPackagesCountByStatusAdminResponse OK
     * @throws ApiError
     */
    public static getPackagesCountByStatusAdmin({
        statuses,
        regionIds,
        fromDate,
        toDate,
    }: {
        statuses?: Array<PackageStatus>,
        regionIds?: Array<number>,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetPackagesCountByStatusAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/packages/count-by-status',
            query: {
                'statuses': statuses,
                'regionIds': regionIds,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
